/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { Item } from "./Item";
import type { PaymentEventPropertiesUserType } from "./PaymentEventPropertiesUserType";
import type { Product } from "./Product";

/**
 * The property payload payment events send.
 */
export interface PaymentEventProperties {
  user_id: string;
  checkout_session_id: string;
  products: Product[];
  items: Item[];
  currency: string;
  payment_track?: string | null;
  visit_type?: string | null;
  state?: string | null;
  current_url?: string | null;
  conversation_id?: string | null;
  user_progression_id?: string | null;
  product_option?: string | null;
  pricing_population?: string | null;
  value?: number | null;
  price?: number | null;
  discount?: number | null;
  insurance_blended_value?: number | null;
  is_first_payment?: boolean | null;
  is_new_user?: boolean | null;
  user_type?: PaymentEventPropertiesUserType;
  coupon?: string | null;
  transaction_id?: string | null;
  revenue?: number | null;
  payment_method?: string | null;
}
